import styled from "styled-components";
import { getToneTokens } from "../../styles/shared";

// .block canônico (Bloco D): surface + border + radius-xl + head/body.
export const BlockRoot = styled.section`
  background: var(--surface);
  border: 1px solid
    ${({ $tone }) =>
      $tone && $tone !== "default"
        ? getToneTokens(null, $tone).border
        : "var(--border)"};
  border-radius: var(--radius-xl);
  overflow: hidden;
  min-width: 0;
`;

export const BlockHead = styled.header`
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-5);
  border-bottom: 1px solid var(--divider);
`;

/* Variante colapsável do head: continua sendo um <header> flex (NÃO um
   <button>) para que `actions` interativas (ex.: "Criar orçamento") não
   fiquem aninhadas dentro de um botão (HTML inválido + clique vazaria pro
   toggle). O gatilho de colapso é só o BlockHeadToggle (título + chevron). */
export const BlockHeadCollapsible = styled(BlockHead)`
  padding: 0;

  &:hover {
    background: transparent;
  }
`;

/* Botão que ocupa a faixa do título e dispara o colapso. Acessível
   (role nativo de button, aria-expanded no JSX, focus-visible). */
export const BlockHeadToggle = styled.button`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-5);
  appearance: none;
  background: transparent;
  border: 0;
  text-align: left;
  cursor: pointer;
  color: inherit;
  font: inherit;

  &:hover {
    background: var(--surface-2);
  }

  &:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: -2px;
  }
`;

export const BlockTitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const BlockTitle = styled.h2`
  font-family: var(--font-display);
  font-size: var(--text-lg);
  font-weight: 600;
  letter-spacing: var(--tracking-tight);
  color: var(--ink);
  margin: 0;
`;

export const BlockSubtitle = styled.span`
  font-size: var(--text-sm);
  color: var(--ink-3);
`;

export const BlockActions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  margin-left: auto;
  flex-shrink: 0;
`;

/* Actions na variante colapsável: ficam fora do botão de toggle, com o
   padding-right do head para alinhar à borda. */
export const BlockActionsCollapsible = styled(BlockActions)`
  margin-left: 0;
  padding-right: var(--space-5);
`;

/* Chevron do head colapsável. Roda 0/-90deg conforme aberto/fechado com
   transição suave. */
export const BlockChevron = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--ink-3);
  flex-shrink: 0;
  margin-left: auto;
  transition: transform 0.2s ease;
  transform: rotate(${({ $collapsed }) => ($collapsed ? "-90deg" : "0deg")});
`;

export const BlockBody = styled.div`
  ${({ $padded }) => $padded && "padding: var(--space-5);"}
  min-width: 0;
`;

/* Wrapper que anima a transição abrir/fechar do corpo colapsável.
   grid-template-rows 0fr<->1fr é a técnica canônica de "auto height"
   animável (sem medir altura em JS). Opacidade acompanha. */
export const BlockCollapse = styled.div`
  display: grid;
  grid-template-rows: ${({ $collapsed }) => ($collapsed ? "0fr" : "1fr")};
  opacity: ${({ $collapsed }) => ($collapsed ? 0 : 1)};
  transition: grid-template-rows 0.22s ease, opacity 0.22s ease;

  /* Filho único precisa de overflow hidden + min-height 0 para a linha 0fr
     realmente cortar o conteúdo durante a animação. */
  > * {
    overflow: hidden;
    min-height: 0;
  }
`;
